"use strict";

exports.__esModule = true;
exports.date = void 0;

var _utils = require("@bydesign-ui/utils");

var _util = require("../../util");

var date = (0, _util.wrapSyncFunc)(function (rule, value) {
  var format = rule.format,
      locale = rule.locale;

  if (format == null || typeof value !== 'string' || value === '') {
    return;
  }

  try {
    return (0, _utils.parseDate)(value, format, locale) != null;
  } catch (e) {
    return false;
  }
});
exports.date = date;